import _JSXStyle from "styled-jsx/style";
import { colors } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';
export const NoticeBoxTitle = _ref => {
  let {
    title,
    dataTest
  } = _ref;
  if (!title) {
    return null;
  }
  return /*#__PURE__*/React.createElement("h6", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["1334557505", [colors.grey900]]])
  }, title, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1334557505",
    dynamic: [colors.grey900]
  }, [`h6.__jsx-style-dynamic-selector{color:${colors.grey900};font-size:14px;font-weight:500;line-height:19px;margin:0;}`]));
};
NoticeBoxTitle.propTypes = {
  dataTest: PropTypes.string.isRequired,
  title: PropTypes.string
};